import { render, staticRenderFns } from "./RedPacketScreen.vue?vue&type=template&id=bdb04540&scoped=true"
import script from "./RedPacketScreen.vue?vue&type=script&lang=js"
export * from "./RedPacketScreen.vue?vue&type=script&lang=js"
import style0 from "./RedPacketScreen.vue?vue&type=style&index=0&id=bdb04540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb04540",
  null
  
)

export default component.exports